import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { PageIntro } from "@/components/PageIntro";
import { ServiceRow } from "@/components/ServiceRow";
import { ProcessSteps } from "@/components/ProcessSteps";
import { CtaBanner } from "@/components/CtaBanner";
import { SERVICES } from "@/data/services";

export default function Services() {
  return (
    <>
      <Seo
        title="Design Services — Branding, Logo, Packaging & Website Design UK"
        description="Graphic design, logo design, brand identity, brochures, packaging, website design, UI design and digital content creation from PRPO LTD, a UK design company."
        path="/services"
      />
      <PageIntro
        testid="services-intro"
        label="Services"
        lines={[{ content: "Design services for" }, { content: "brands that want", className: "text-royal" }, { content: "to be remembered." }]}
        text="From a single logo to a complete identity, packaging range or website, every PRPO LTD project is shaped around your business, your audience and your goals."
      >
        <nav aria-label="Service index" className="mt-14 border-t border-[var(--line)] pt-6">
          <ul className="flex flex-wrap gap-2">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link to={`/services#${s.slug}`} data-testid={`service-index-${s.slug}`} className="inline-flex items-center gap-2 rounded-full border border-navy/15 px-4 py-2 text-sm font-medium text-navy transition-colors duration-300 hover:border-royal hover:bg-royal hover:text-white">
                  <span className="font-mono text-[0.7rem] opacity-70">{s.n}</span>{s.title}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </PageIntro>
      {SERVICES.map((s) => <ServiceRow key={s.slug} service={s} />)}
      <ProcessSteps index="09" />
      <CtaBanner />
    </>
  );
}
